import product_images from "./images/index.jsx";

export const data = [

  {
    id: "CJJT1244965",
    name: "Butterfly Quilling Illustration",
    company: "eosp",
    price: 2099,
    colors: ["#ffc0cb", "#0000ff", "#cdd0d0"],
    image: product_images.product1.product1_2,
    description:
    "20 Inch Butterfly Quilling Illustration Material Pack Slot",
    category: "decoration",
    featured: true,
  },
  {
    id: "CJMY1687359",
    name: "Cute Bunny Hat",
    company: "discountify",
    price: 3499,
    colors: ["#000", "#22d3ef"],
    image: product_images.product2.product2_1,
    description:
    "Plush Cartoon Cat Dog Rabbit Ears Cute Easter decoration Hat Head Cover Pets Products",
    category: "fashion",
    shipping: true,
  },
  {
    id: "CJCF117252405EV",
    name: "Man Prescription Glasses",
    company: "easy order",
    price: 3050,
    colors: ["#22d3ef", "#cdd0d0"],
    image: product_images.product3.product3_1,
    description:
    "Sunglasses Driving Special Anti-ultraviolet Sunglasses For Day And Night",
    category: "fashion",
    featured: true,

  },
  {
    id: "CJZBNSSZ00061",
    name: "Digital Watches",
    company: "discountify",
    price: 2800,
    colors: ["#000", "#ffc0cb", "#cdd0d0"],
    image: product_images.product4.product4_1,
    description:
    "Vintage clock fashion digital wall clock",
    category: "accessories",
    shipping: true,
  },
  {
    id: "CJEJ1596832",
    name: "Headphones",
    company: "eosp",
    price: 3000,
    colors: ["#000", "#cdd0d0"],
    image:  product_images.product5.product5_1,
    description:
    "Wireless Light-emitting Bluetooth Headphones",
    category: "fashion",
    shipping: true,
  },
  {
    id: "CJJJCWMY01530",
    name: "Cat Supplies",
    company: "simple ship",
    price: 1600,
    colors: ["#ffc0cb", "#cdd0d0"],
    image: product_images.product6.product6_1 ,
    description:
    "Vest-style Chest Strap For Cats",
    category: "fashion",
    shipping: true,
    featured: true,
  },
  {
    id: "CJDS1094193",
    name: "Man T-shirts",
    company: "discountify",
    price: 2550,
    colors: ["#cdd0d0", "#000"],
    image: product_images.product7.product7_1,
    description:
    "Round Neck Korean Short-Sleeved T-Shirt Men'S Color Matching Men'S T-Shirt Clothes",
    category: "fashion",
    shipping: true,
  },
  {
    id: "CJJJJTJT03804",
    name: "decoration",
    price: 5000,
    company: "simple ship",
    colors: ["#000", "#cdd0d0"],
    image: product_images.product8.product8_1,
    description:
    "Home/Office decoration",
    category: "decoration",
    featured: true,
    shipping: true,
  },
  {
    id: "CJWJWJJM00057",
    name: "toys",
    price: 2299,
    company: "discountify",
    colors: ["#ffc0cb"],
    image: product_images.product9.product9_1,
    description:
    "Children's intelligence puzzle toys educational toys",
    category: "toys",
    shipping: true,
  },
  {
    id: "CJWJWJMR00206",
    name: "toys",
    company: "discountify",
    price: 2299,
    colors: ["#ff0000", "#22d3ef", "#ffc0cb"],
    image: product_images.product10.product10_1,
    description:
    "Creative Animal Plush toys",
    category: "toys",
    featured: true,
  },
];
